<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <custom-divider label="تنظیمات پایه"></custom-divider>
                <v-row dense>
                    <v-col>
                        <v-select
                            :items="[{ name: 'ایمیل', id: 'email' }, { name: 'شماره موبایل', id: 'mobile' }, { name: 'نام کاربری', id: 'username' }]"
                            item-title="name"
                            item-value="id"
                            label="نوع نام کاربری"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.username_type"
                        ></v-select>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'با انتخاب گزینه نام کاربری، کاربران مجاز به استفاده از هر نوع عبارتی برای نام کاربری خود خواهند بود'" class="cursor-help mt-3" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-select
                    :items="authenticateItems"
                    item-title="name"
                    item-value="id"
                    label="روش احراز کاربران سازمانی"
                    v-model="form.authenticate_employees_type"
                ></v-select>
                <v-select
                    :items="authenticateItems"
                    item-title="name"
                    item-value="id"
                    label="روش احراز مشتریان"
                    v-model="form.authenticate_customers_type"
                ></v-select>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="مثال نام کاربری"
                            ref="usernameExample"
                            v-model="form.username_example"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'این متن الگوی مجاز نام کاربری را در زمان ثبت نام به کاربران نمایش خواهد داد'" class="cursor-help mt-3" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="الگوی Regex نام کاربری"
                            v-model="form.username_regex"
                            dir="ltr"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'تنظیم این گزینه امکان تعریف یک الگوی مشخص برای نام کاربری را امکان‌پذیر خواهد کرد'" class="cursor-help mt-3" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-checkbox
                    class="mt-0"
                    hide-details
                    label="اجازه تغییر نام کاربری توسط کاربران"
                    v-model="form.username_change_permission"
                ></v-checkbox>
                <v-checkbox
                    hide-details
                    label="امکان ورود کاربران منقضی شده"
                    v-model="form.expired_customers_can_login"
                ></v-checkbox>
                <custom-divider class="mt-5" label="تنظیمات ثبت نام مشتریان"></custom-divider>
                <v-checkbox
                    hide-details
                    label="اجازه ایجاد حساب کاربری توسط مشتریان"
                    v-model="form.signup_from_customers_permission"
                    class="mt-0"
                ></v-checkbox>
                <v-row align="center" class="mt-0" dense>
                    <v-col cols="auto">
                        <v-checkbox
                            hide-details
                            label="احراز هویت با ارسال کد فعال‌سازی به ایمیل/موبایل کاربر"
                            v-model="form.authentication_users"
                            class="mt-0"
                            :disabled="form.username_type == 'username' || form.authenticate_customers_type == 'otp'"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'در صورت غیرفعال بودن این گزینه حساب کاربری مشتریان ثبت نام شده به صورت پیش‌فرض فعال خواهد بود'" class="cursor-help" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings'})" class="ms-2" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "تنظیمات حساب کاربری",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            form: {
                username_type: this.$system.settings.username_type,
                username_example: this.$system.settings.username_example,
                username_regex: this.$system.settings.username_regex,
                authenticate_employees_type: this.$system.settings.authenticate_employees_type,
                authenticate_customers_type: this.$system.settings.authenticate_customers_type,
                username_change_permission: this.$system.settings.username_change_permission,
                signup_from_customers_permission: this.$system.settings.signup_from_customers_permission,
                authentication_users: this.$system.settings.authentication_users,
                expired_customers_can_login: this.$system.settings.expired_customers_can_login,
            },
        };
    },
    computed: {
        authenticateItems() {
            let items = [{name: 'کلمه عبور هلپیکال', id: 'database'}];
            if(this.$system.license.features.otp)
                items.push({name: 'یک بار رمز (OTP)', id: 'otp'});
            if(this.$system.license.features.active_directory)
                items.push({name: 'اکتیو دایرکتوری', id: 'active_directory'})
            return items;
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.$updateSettings({...this.form, _method: 'put'}).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$system.setGlobalSettings(true);
                    this.$system.setSystemSettings(true);
                    this.$toast.success(res.message);
                }
            }).finally(()=>{this.loading = false});
        },
    },
};
</script>
